import { styled } from "@mui/material"
import { SnackbarProvider } from "notistack"
import { MaterialDesignContent } from "notistack"

const CustomSnackbar = styled(MaterialDesignContent)(() => ({
  "&.notistack-MuiContent-default": {
    backgroundColor: "var(--mui-palette-background-default)",
    borderRadius: "12px",
    boxShadow: "0px 4px 13.4px 0px rgba(0, 0, 0, 0.05)",
    border: "1px solid var(--mui-palette-borderSecondary)",
    color: "var(--mui-palette-text-primary)",
  },
  "&.notistack-MuiContent-error": {
    backgroundColor: "#970C0C",
  },
}))

export function MySnackbarProvider() {
  return (
    <>
      <SnackbarProvider
        maxSnack={10}
        Components={{
          default: CustomSnackbar,
          info: CustomSnackbar,
          warning: CustomSnackbar,
          success: CustomSnackbar,
          error: CustomSnackbar,
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      />
    </>
  )
}
